// Revolt Slider — range input with dark track and Revolt red fill
import React, { useMemo } from 'react';
import './RevoltSlider.css';

/**
 * @param {{
 *   min?: number,
 *   max?: number,
 *   step?: number,
 *   value: number,
 *   onChange?: (value: string) => void,
 *   onCommit?: (value: string) => void,
 *   disabled?: boolean,
 *   variant?: 'primary' | 'ghost',
 *   className?: string,
 *   id?: string,
 *   'aria-label'?: string,
 * }} props
 */
export function RevoltSlider({
  min = 0,
  max = 100,
  step = 1,
  value,
  onChange,
  onCommit,
  disabled = false,
  variant = 'primary',
  className = '',
  id,
  'aria-label': ariaLabel,
  ...props
}) {
  const numericValue = Number(value);

  const fillPercent = useMemo(() => {
    if (!Number.isFinite(numericValue)) return 0;
    if (max === min) return 0;
    return Math.min(
      100,
      Math.max(0, ((numericValue - min) / (max - min)) * 100)
    );
  }, [numericValue, min, max]);

  const classes = [
    'revolt-slider',
    `revolt-slider--${variant}`,
    disabled ? 'is-disabled' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <input
      id={id}
      type="range"
      className={classes}
      min={min}
      max={max}
      step={step}
      value={Number.isFinite(numericValue) ? numericValue : min}
      disabled={disabled}
      aria-label={ariaLabel}
      style={{ '--revolt-slider-fill': `${fillPercent}%` }}
      onChange={(e) => onChange?.(e.target.value)}
      onMouseUp={(e) => onCommit?.(e.currentTarget.value)}
      onTouchEnd={(e) => onCommit?.(e.currentTarget.value)}
      {...props}
    />
  );
}
